import { CurrentProductProvider } from '@/src/context/product/current-product-context'
import React, { useEffect, useState } from 'react'
import Modal from '../../helpers/overlays/modal/modal'
import ProductBottom from '../modal-product-components/product-bottom/product-bottom'
import ProductContent from '../modal-product-components/product-content/product-content'
import ProductDetails from '../modal-product-components/product-details/product-details'
import ProductHeader from '../modal-product-components/product-header/product-header'
import styles from './styles.module.scss'
import Items from '@/src/interfaces/catalog/items'
import PathHelper from '@/src/helpers/path-helper'
import { Overlay } from '../../helpers/overlays/overlay'
import ProductImage from '../modal-product-components/product-image/product-image'

interface Props {
    product?: Items.ItemResponse
    isOpen: boolean
    id?: string
    name?: string
    onClose: () => void
}

export default function FullProduct(props: Props) {
    const [hasLoadedContent, setHasLoadedContent] = useState(false)
    const [hasError, setHasError] = useState(false)

    const id = props.product?.id ?? props.id
    const name = props.product?.name ?? props.name

    if (!id || !name) return <></>

    const handleModalClose = () => {
        PathHelper.clearQueryParams()
        props.onClose()
    }

    useEffect(() => {
        if (hasError)
            Overlay.dismiss()
    }, [hasError])

    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            event.preventDefault()
            handleModalClose()
        }

        window.addEventListener('popstate', handlePopState)

        return () => {
            window.removeEventListener('popstate', handlePopState)
        }
    }, [])

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        params.set('produto', name)
        params.set('item', id)
        window.history.pushState(null, "", `?${params.toString()}`)
    }, [])

    return (
        <CurrentProductProvider>
            <Modal
                options={{
                    headProps: { elToObserveId: "modal-product-header", headTitle: name },
                    hasLoadedContent: hasLoadedContent,
                    animation: window.innerWidth > window.innerHeight ? 'pop' : 'fade',
                    enableCloseButton: false
                }}
                onClose={handleModalClose}
                isOpen={props.isOpen}
                isInterceptRouting={false}
                className={styles.modalContainer}
            >
                <ProductContent setHasLoadedContent={setHasLoadedContent} setHasError={setHasError} id={id}>
                    <ProductImage />
                    <ProductHeader />
                    <ProductDetails />
                    <ProductBottom />
                </ProductContent>
            </Modal>
        </CurrentProductProvider>
    )
}
